// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"191":"AdminPics","353":"AdminText","884":"admin","966":"login"}[chunkId] || chunkId) + "." + {"112":"07f9e5a9","191":"40836d22","353":"fdd3bdf4","884":"a4255e50","966":"8af504e7"}[chunkId] + ".css";
};